(ns net.kestec.mhda-pilgrimage.lib-ui.form-components
  (:require
    ["@mui/material/Grid" :default Grid]
    ["@mui/material/TextField" :default TextField]
    ["@mui/material/Checkbox" :default Checkbox]
    ["@mui/material/RadioGroup" :default RadioGroup]
    ["@mui/material/Radio" :default Radio]
    ["@mui/material/Select" :default Select]
    ["@mui/material/MenuItem" :default MenuItem]
    ["@mui/material/InputLabel" :default InputLabel]
    ["@mui/material/Switch" :default Switch]
    ["@mui/material/FormLabel" :default FormLabel]
    ["@mui/material/FormControl" :default FormControl]
    ["@mui/material/FormHelperText" :default FormHelperText]
    ["@mui/material/FormGroup" :default FormGroup]
    ["@mui/material/FormControlLabel" :default FormControlLabel]

    [net.kestec.mhda-pilgrimage.db :as-alias db]
    [day8.re-frame.http-fx]
    [reagent.core :as r]
    ))



(defn grid-small [& args]
  (into [:> Grid
         (merge {:xs 12 :md 6 :lg 4 :sx {:padding "7px"}}
                (if (map? (first args)) (first args) {}))
         ]
        (if (map? (first args)) (rest args) args)))

(defn grid-medium [& args]
  (into [:> Grid
         (merge {:xs 12 :md 12 :lg 6 :sx {:padding "7px"}}
                (if (map? (first args)) (first args) {}))
         ]
        (if (map? (first args)) (rest args) args)))

(defn grid-full [& args]
  (into [:> Grid
         (merge {:xs 12 :sx {:padding "7px"}}
                (if (map? (first args)) (first args) {}))
         ]
        (if (map? (first args)) (rest args) args)))

(defn text-field [& args]
  (let [args (if (map? (first args)) (first args) {})
        val (:value args)
        args (dissoc args :value)]
    (into [:> TextField
           (merge {:label           "Textfield 1"
                   :fullWidth       true
                   :defaultValue    val
                   :size            "small"
                   :sx              (merge (or (:sx args) {})
                                           (when (:viewOnly args) [:background-color "#fafafa"]))
                   :InputLabelProps {:disableAnimation true :shrink true}}
                  args
                  (when (:viewOnly args) [:slotProps {:input {:reanOnly true}}])
                  {:onChange #((or (:onChange args) (fn [_])) (.. % -target -value))}
                  )
           ]
          )))

(defn date-field [& args]
  (let [args (if (map? (first args)) (first args) {})
        val (:value args)
        args (dissoc args :value)]
    (into [:> TextField
           (merge {:label           "Textfield 1"
                   :type            "date"
                   :fullWidth       true
                   :defaultValue    val
                   :size            "small"
                   :sx              (merge (or (:sx args) {})
                                           (when (:viewOnly args) [:background-color "#fafafa"]))
                   :InputLabelProps {:disableAnimation true :shrink true}}
                  args
                  (when (:viewOnly args) [:slotProps {:input {:reanOnly true}}])
                  {:onChange #((or (:onChange args) (fn [_])) (.. % -target -value))}
                  )
           ]
          )))


(defn text-field-multi [& args]
  (let [params (merge {:minRows 4 :maxRows 8 :multiline true} (if (map? (first args)) (first args) {}))
        rest (if (map? (first args)) (rest args) args)]
    (apply text-field (conj [params] rest))))

(defn checkbox [& args]
  (let [{:keys [label onChange error helperText] :as params} (if (map? (first args)) (first args) {})
        rest (if (map? (first args)) (rest args) args)]
    (into [:> FormControl {:error error}
           [:> FormControlLabel
            (merge {:error   error
                    :control (r/as-element [:> Checkbox {:error error}])}
                   params
                   {:onChange #((or onChange (fn [_ _])) (.. % -target -checked) (.. % -target -value))})]
           [:> FormHelperText {:error error} helperText]]
          rest)))

(defn checkbox-group [options & params]
  (into [:> FormGroup]
        (mapv (fn [[k v]]
                [:> FormControlLabel {:label k :value v :control (r/as-element [:> Checkbox {}])}])
              options)))

(defn radio [& args]
  (into [:> RadioGroup [:> FormControlLabel
                        (merge {:label   "Radio 1"
                                :control (r/as-element [:> Radio {}])}
                               (if (map? (first args)) (first args) {}))]]
        ))

(defn radio-group [options & args]
  (let [{:keys [label onChange error helperText value]} (if (map? (first args)) (first args) {})
        rest (if (map? (first args)) (rest args) args)]
    [:<>
     [:> FormControl {:sx    {:flexDirection {:xs "column" :md "row"}}
                      :error error}
      (when label [:> FormLabel {:sx {:marginRight "30px"}} label])
      (into [:> RadioGroup {:row      true
                            :onChange #((or onChange (fn [_ _])) (.. % -target -checked) (.. % -target -value))
                            :value    value}]
            (mapv (fn [[k n]]
                    [:> FormControlLabel {:label n :value k :control (r/as-element [:> Radio])}])
                  options))
      ]
     [:> FormHelperText {:error error} helperText]
     rest]))

(defn radio-yes-no [& args]
  (let [{:keys [label onChange value] :as params} (if (map? (first args)) (first args) {})]
    [radio-group
     {"yes" "Ja" "no" "Nein"}
     (merge params
            {:label    label
             :value    (when (boolean? value) (if (true? value) "yes" "no"))
             :onChange (fn [b v]
                         ;(js/console.log "onChange -- " v "-" b)
                         (onChange (= "yes" v)))
             }

            )]))

(defn switch [& args]
  (into [:> FormControlLabel (merge {:label "Switch Name" :value "value1" :control (r/as-element [:> Switch {:label "Switch 2" :value "value2"}])}
                                    (if (map? (first args)) (first args) {}))]
        ))


(defn select [& args]
  (let [{:keys [label onChange error helperText value options]} (if (map? (first args)) (first args) {})
        rest (if (map? (first args)) (rest args) args)
        id (hash (str "select-" label "-" (rand-int 10000)))
        labelId (str "label-" id)
        describedbyId (str "descr-" id)
        option-items (if options
                       (for [v options] [:> MenuItem {:value v} v])
                       rest)
        ]
    [:> FormControl
     {:fullWidth true
      :error     error}
     [:> InputLabel
      {:id labelId} label]
     (into
       [:> Select
        (merge
          {:id               id
           :labelId          labelId
           :aria-describedby describedbyId
           :error            error
           :value            (or value "")
           :fullWidth        true
           :label            label}
          (when onChange [:onChange #(onChange (.. % -target -value))])
          )
        ]
       option-items)
     [:> FormHelperText {:id describedbyId :error error} helperText]]))



